import moment from 'moment';

const DATE_FORMAT_DISPLAY = 'MM/DD/YYYY';

/**
 * Convert given value into a string formatted as a date.
 *
 * @param value {String|Moment|Date}
 * @param format {String} Date format to return string in, such as "YYYY-MM-DD"
 * @returns {string}
 */
const DateFilter = (value, format = DATE_FORMAT_DISPLAY) => {
  if (value) {
    // Value compatible as-is with moment
    if (moment.isMoment(value) || value instanceof Date) {
      return moment(value).format(format);
    }

    const stringInput = String(value);

    // Find the format of the date string
    const inputFormatToRegex = [
      // August 17, 2022 as "2022-08-17"
      ['YYYY-MM-DD', /^\d{4}-\d{2}-\d{2}$/],
      // August 17, 2022 as "8-17-22"
      // January 2, 2022 as "1-2-2022"
      ['MM-DD-YYYY', /^\d{1,2}-\d{1,2}-\d{2,4}$/],
      // August 17, 2022 11:45:22pm as "2022-08-17 23:45:22"
      ['YYYY-MM-DD HH:mm:ss', /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/],
      // August 17, 2022 as "8/17/22"
      // January 2, 2022 as "1/2/2022"
      // November 23, 2022 as "11/23/2022"
      ['MM/DD/YYYY', /^\d{1,2}\/\d{1,2}\/\d{2,4}$/],
    ];
    for (let [inputFormat, regex] of inputFormatToRegex) {
      if (stringInput.match(regex)) {
        return moment(stringInput, inputFormat).format(format);
      }
    }

    return moment(stringInput).format(format);
  }
};

export default DateFilter;
